module.exports = __webpack_public_path__ + "img/qrcode-raplatform.4f5d4060.jpg";